export default "__VITE_ASSET__Bxex5aC1__"